import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["title", "theme", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
import { SrOnly } from '../Helper';
var styles = {
  "root": "Dots-root_WFBVz",
  "icon": "Dots-icon_hULpH",
  "pulse": "Dots-pulse_1hG6n",
  "theme-light": "Dots-theme-light_13XXB",
  "theme-dark": "Dots-theme-dark_ru1oI"
};
var Dot = function Dot() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 5 5",
    width: "5",
    height: "5",
    className: styles.icon,
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "2.5",
    cy: "2.5",
    r: "2.5"
  }));
};
function Dots(_ref) {
  var title = _ref.title,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      tagName: "span",
      flex: true,
      flexJustifyBetween: true,
      className: clsx(styles.root, styles["theme-".concat(theme)], className)
    }, extraProps), /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(SrOnly, null, title))
  );
}
export default Dots;